import React from 'react';
import CursorSelection from './CursorSelection';
import * as styles from './LinkCursorSelection.module.scss';
import { useQuill } from './QuillContext';
import { useRangeSaver } from './RangeSaver';

const LinkCursorSelection = () => {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const { quill, editingLink } = useQuill();
  const range = useRangeSaver(quill);

  return editingLink && range && quill ? (
    <div className={styles.container}>
      <CursorSelection
        className={styles.link}
        quill={quill}
        mark={{ type: 'plain', ...range }}
      />
    </div>
  ) : null;
};

export default LinkCursorSelection;
